import fetchWrapper from '@http/fetchWrapper';
import type { I18nPostBody, I18nTranslatePostBody } from '@eye-able/types';
import { useMutation } from '@tanstack/react-query';
import { api } from '@http/constants';

export const useTranslationActions = () => {
  const saveAction = useMutation({
    mutationFn: (body: I18nPostBody) => fetchWrapper.post<void>(api.i18n, body),
  });

  const translateAction = useMutation({
    mutationFn: (body: I18nTranslatePostBody) =>
      fetchWrapper.post<Record<string, string>>(api.i18nTranslate, body),
  });

  const flushCacheAction = useMutation({
    mutationFn: (version: string) =>
      Promise.allSettled([
        fetchWrapper.delete<void>(
          'https://apiv3amswswtgou9-api-ams-preview.functions.fnc.nl-ams.scw.cloud/api/i18n/cache',
          { version },
        ),
        fetchWrapper.delete<void>(
          'https://apiv3amswswtgou9-api-ams.functions.fnc.nl-ams.scw.cloud/api/i18n/cache',
          { version },
        ),
      ]),
  });

  return {
    saveAction,
    translateAction,
    flushCacheAction,
  };
};
